import { useState } from "react";
import { BarChart2, TrendingUp } from "lucide-react";
import SiteSelector         from "../groups/components/SitesSection/SiteSelector";
import SitePerformancePanel from "./components/performance/SitePerformancePanel";
import { SITES }            from "../groups/types/Emailstypes";
import GoogleAnalyticsAdvanced from "./components/analytics/GoogleAnalyticsAdvanced";

const Dashboard: React.FC = () => {
  const [selectedSiteId,  setSelectedSiteId]  = useState<string | null>(null);
  const [confirmedSiteId, setConfirmedSiteId] = useState<string | null>(null);

  const confirmedSite = SITES.find(s => s.id === confirmedSiteId) ?? null;

  const handleConfirmSite = (id: string) => {
    setSelectedSiteId(id);
    setConfirmedSiteId(id);
  };

  return (
    <div className="min-h-screen  ">
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .anim-fade  { animation: fadeUp 0.3s ease both; }
        .anim-fade2 { animation: fadeUp 0.35s 0.05s ease both; }
      `}</style>

<div className="w-full px-4 sm:px-6 lg:px-8 py-8 space-y-6">

         <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-[#0F52BA] to-blue-400
            flex items-center justify-center shadow-sm shadow-blue-200">
            <TrendingUp size={18} className="text-white" />
          </div>
          <div>
            <h1 className="text-[17px] font-bold text-slate-800 leading-tight">Tableau de bord</h1>
            <p className="text-[11px] text-slate-400">Performances GBP & Analytics</p>
          </div>
        </div>

         <section className="space-y-4">

           <div className="flex items-center gap-2">
            <div className="w-1 h-4 rounded-full bg-[#0F52BA]" />
            <span className="text-[12px] font-bold text-slate-500 uppercase tracking-widest">
              Google Business Profile
            </span>
          </div>

           <div className="bg-white rounded-2xl border border-slate-100 shadow-sm px-6 py-5 anim-fade">
            <SiteSelector
              selectedSiteId={selectedSiteId}
              onSelect={setSelectedSiteId}
              onConfirm={handleConfirmSite}
            />
          </div>

           {confirmedSite ? (
            <div
              key={confirmedSite.id}
              className="bg-white rounded-2xl border border-slate-100 shadow-sm px-6 py-6 anim-fade"
            >
               <div
                className="h-0.5 w-full rounded-full mb-5 opacity-70"
                style={{ background: `linear-gradient(90deg, ${confirmedSite.color}, transparent)` }}
              />
              <SitePerformancePanel site={confirmedSite} />
            </div>
          ) : (
            <div className="bg-white rounded-2xl border border-dashed border-slate-200 px-6 py-16
              flex flex-col items-center justify-center text-center anim-fade">
              <div className="w-14 h-14 rounded-2xl bg-blue-50 flex items-center justify-center mb-4
                shadow-sm shadow-blue-100">
                <BarChart2 size={24} className="text-[#0F52BA] opacity-70" />
              </div>
              <p className="text-[13px] font-semibold text-slate-600 mb-1">
                Sélectionnez un site
              </p>
              <p className="text-[11px] text-slate-400 max-w-[220px] leading-relaxed">
                Choisissez un réseau dans le sélecteur ci-dessus pour visualiser les KPIs globaux.
              </p>
            </div>
          )}
        </section>

         <div className="flex items-center gap-3 py-1">
          <div className="flex-1 h-px bg-slate-200" />
          <span className="text-[10px] font-bold text-slate-300 uppercase tracking-widest px-2">
            Analytics
          </span>
          <div className="flex-1 h-px bg-slate-200" />
        </div>

         <section className="space-y-4 anim-fade2">
          <div className="flex items-center gap-2">
            <div className="w-1 h-4 rounded-full bg-orange-500" />
            <span className="text-[12px] font-bold text-slate-500 uppercase tracking-widest">
              Google Analytics
            </span>
          </div>
          <GoogleAnalyticsAdvanced />
        </section>

      </div>
    </div>
  );
};

export default Dashboard;